import React, { useEffect, useState } from "react";

const MESSAGES = [
  "Analyse de vos réponses...",
  "Calcul de votre score...",
  "Génération de votre profil...",
];

const AnalysisScreen = ({ onDone }) => {
  const [progress, setProgress] = useState(0);
  const [msgIndex, setMsgIndex] = useState(0);

  useEffect(() => {
    const msgTimer = setInterval(() => {
      setMsgIndex((i) => Math.min(i + 1, MESSAGES.length - 1));
    }, 1000);

    const progTimer = setInterval(() => {
      setProgress((p) => {
        if (p >= 100) {
          clearInterval(progTimer);
          clearInterval(msgTimer);
          setTimeout(onDone, 400);
          return 100;
        }
        return p + 2;
      });
    }, 60);

    return () => {
      clearInterval(progTimer);
      clearInterval(msgTimer);
    };
  }, [onDone]);

  return (
    <div
      style={{
        minHeight: "100vh",
        /* backgroundColor: "#12354D", */
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px 16px",
      }}
    >
      <div style={{ width: "100%", maxWidth: 480 }}>
        <div className="card p-10 text-center">
          {/* Animated icon */}
          <div className="flex justify-center mb-6">
            <div
              className="animate-pulse-slow"
              style={{
                width: 80,
                height: 80,
                borderRadius: 20,
                backgroundColor: "#12354D",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                <circle cx="20" cy="20" r="16" stroke="#B5163A" strokeWidth="2.5" fill="none" />
                <path
                  d="M12 20 L17 25 L28 15"
                  stroke="#B5163A"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="none"
                />
              </svg>
            </div>
          </div>

          <h2
            style={{
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 700,
              fontSize: 20,
              color: "#12354D",
              marginBottom: 8,
            }}
          >
            Analyse en cours...
          </h2>

          <p
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: 14,
              color: "#6B7280",
              marginBottom: 28,
              minHeight: 20,
            }}
          >
            {MESSAGES[msgIndex]}
          </p>

          {/* Progress bar */}
          <div
            style={{
              width: "100%",
              height: 8,
              backgroundColor: "#F3F4F6",
              borderRadius: 4,
              overflow: "hidden",
              marginBottom: 10,
            }}
          >
            <div
              style={{
                height: "100%",
                width: `${progress}%`,
                backgroundColor: "#B5163A",
                borderRadius: 4,
                transition: "width 0.1s linear",
              }}
            />
          </div>

          <p
            style={{
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 700,
              fontSize: 14,
              color: "#B5163A",
            }}
          >
            {progress}%
          </p>
        </div>
      </div>
    </div>
  );
};

export default AnalysisScreen;
